enum Breakpoint {
    sm = 0,
    md = 768,
    lg = 1018,
}

export default Breakpoint;
